// if you are missing these secrets, 
// run ./tools/scripts/f5/fetch-secrets.ts
// ps - this file should never be auto-generated.
// add these exports _manually_ when creating new secrets.
// this file is designed to throw compiler errors when you
// are missing secrets.
export * from './secrets/firebase';
export * from './secrets/facebook';
export * from './secrets/sendgrid';
export * from './secrets/reddit';
export * from './secrets/stripe';
export * from './secrets/firebase-admin-sdk';